import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import PageHeader from '../../components/common/PageHeader';
import TwoFactorSettings from '../../components/settings/TwoFactorSettings';
import WorkerVisibilitySettings from '../../components/settings/WorkerVisibilitySettings';

const SettingsPage = () => {
  const { isAdmin } = useAuth();
  
  return (
    <div className="space-y-6 animate-fade-in">
      <PageHeader 
        title="Settings"
        description="Manage your account and system settings"
      />

      <div className="max-w-2xl space-y-6">
        {/* Account Security */}
        <TwoFactorSettings />
        
        {/* Admin-only: Worker Visibility Settings */}
        {isAdmin && <WorkerVisibilitySettings />}
      </div>
    </div>
  );
};

export default SettingsPage;
